import styled from '@emotion/styled';

export const Title = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 600;
  font-size: 18px;
`;

export const Text = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 500;
  font-size: 14px;
  margin-top: 8px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Column = styled.div<{ width?: number; marginTop?: number }>`
  ${(props) => props.width && `width: ${props.width}%`};
  ${(props) => props.marginTop && `margin-top: ${props.marginTop}px`};
`;

export const ProgressValue = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => props.theme.color.blue.default};
  margin-bottom: 8px;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  transition: opacity 100ms linear;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 1;
  }
  font-size: 16px;
  cursor: pointer;
  padding: 5px;
`;
